exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".background[data-v-079cd7fa]{padding:0px 18px}.midButton[data-v-079cd7fa]{width:350px;margin-top:20px}.table-hr[data-v-079cd7fa]{border-left:3px solid #EBEEF5}.divider[data-v-079cd7fa]{height:10px;background-color:#EBEEF5;border:none}.title-page[data-v-079cd7fa]{color:#b8b5b5}\n", ""]);

// exports
